import { Injectable } from '@angular/core';
import { createStore, select, withProps } from '@ngneat/elf';
import { localStorageStrategy, persistState } from '@ngneat/elf-persist-state';
import { Observable } from 'rxjs';
import { BaseRepository } from '../../../../core/state/base.repository';
import { BusyService } from '../../../../core/services/busy.service';

export interface IProfileState {
  profile: any | null;
  loading: boolean;
}

const initialState: IProfileState = {
  profile: null,
  loading: false,
};

const profileStore = createStore(
  { name: 'profile' },
  withProps<IProfileState>(initialState)
);

// export const profilePersist = persistState(profileStore, {
//   key: 'profile',
//   storage: localStorageStrategy,
// });

@Injectable({ providedIn: 'root' })
export class ProfileRepository extends BaseRepository<IProfileState> {
  profile$: Observable<any> = profileStore.pipe(select((st) => st.profile));
  role$: Observable<any> = profileStore.pipe(select((st) => st.profile?.userRole));
  profileState$: Observable<any> = profileStore.pipe(select((st) => st.profile?.profileState));
  loading$: Observable<boolean> = profileStore.pipe(
    select((state) => state.loading)
  );

  constructor() {
    super('profile', initialState);
  }

  setProfile(profile: IProfileState['profile']): void {
    profileStore.update((st) => ({ ...st, profile }));
  }

  setLoading(loading: boolean): void {
    profileStore.update((state) => ({ ...state, loading }));
  }
}
